import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

import {
  LASSO_HINT_NOTCH_SIZE_PX,
  LASSO_HINT_OPACITY,
  LASSO_LINE_COLOR,
  LASSO_VERTEX_BORDER_PX,
  LASSO_VERTEX_SIZE_PX,
} from "./maplibre-lasso-select.constants";

/** Hollow handle on each placed corner — the same white-disc-with-a-coloured-rim geoman drew. */
export const MapLibreLassoVertexStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-lasso-vertex",
})`
  box-sizing: border-box;
  width: ${LASSO_VERTEX_SIZE_PX}px;
  height: ${LASSO_VERTEX_SIZE_PX}px;
  border-radius: 50%;
  background: ${rydeColors.white};
  border: ${LASSO_VERTEX_BORDER_PX}px solid ${LASSO_LINE_COLOR};
`;

/**
 * The hint that follows the cursor while drawing, telling the user what the next click will do.
 *
 * Geoman showed this through a plain Leaflet tooltip, and the stations map never restyled it — so every
 * value here is Leaflet's own .leaflet-tooltip default, down to the white notch on top that a
 * bottom-facing tooltip drew. MapLibre sets an absolute line-height on the map container, hence the
 * explicit one.
 *
 * Pointer events are off so it can never swallow the click it is describing.
 */
export const MapLibreLassoHintStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-lasso-hint",
})`
  position: relative;
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
  padding: 6px;
  border: 1px solid ${rydeColors.white};
  border-radius: 3px;
  background-color: ${rydeColors.white};
  color: ${greyMui._900};
  font-size: 12px;
  line-height: 1.5;
  opacity: ${LASSO_HINT_OPACITY};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    /* Lifts the notch clear of the box, the way Leaflet's -12px margin did against its 6px borders. */
    transform: translateY(-100%);
    margin-left: -${LASSO_HINT_NOTCH_SIZE_PX}px;
    border: ${LASSO_HINT_NOTCH_SIZE_PX}px solid transparent;
    border-bottom-color: ${rydeColors.white};
    pointer-events: none;
  }
`;
